//import { FormEvent,useState } from 'react';
import deleteImg from '../assets/images/delete.svg';
import logoImg from "../assets/images/logo.svg";
import checkImg from "../assets/images/check.svg";
import answerImg from "../assets/images/answer.svg";

import { useHistory,useParams } from 'react-router-dom'

import { Button } from "../components/Button/index"; 
import { Question } from '../components/Question';
import { RoomCode } from "../components/RoomCode";
//import { useAuth } from '../hooks/UseAuth';
import { useRoom } from '../hooks/useRoom';



import '../styles/room.scss';
import { database } from '../services/firebase';


type RoomParams= {
  id: string;
}

export function AdminRoom(){
  //const {user} = useAuth();
  const history = useHistory();
  const params= useParams<RoomParams>();
  const roomId = params.id;

  const { questions, title } = useRoom(roomId);

  async function handleEndRoom() {
    await database.ref(`rooms/${roomId}`).update({
      endedAt: new Date(),
    });

    history.push('/');
  }

  async function handleDeleteQuestion(questionId: string) {
    if (window.confirm('Tem certeza que você quer excluir essa pergunta?')) {
      await database.ref(`rooms/${roomId}/questions/${questionId}`).remove();
    }
  }

  async function handleCheckQuestionAsAnswered(questionId: string){
    await database.ref(`rooms/${roomId}/questions/${questionId}`).update({
      isAnswered:true,
    });
  }

  async function handleHighlightQuestion(questionId: string){
    await database.ref(`rooms/${roomId}/questions/${questionId}`).update({
      isHighlighted:true,
    });
  }


  return (
    <div id="page-room">
      <header>
        <div className="content">
          <img src={logoImg} onClick={() => history.push('/')}  alt="letmeask" />
          <div>
            <RoomCode code={roomId} />
          </div>
        </div>
      </header>
      
      <main>
        <div className="room-title">
          <h1>Sala {title}</h1>
          { questions.length > 0 && <span>{questions.length} pergunta(s)</span>}
        </div>

        <div className="question-list">
          {questions.map(question => {
            return (
              <Question
                key= {question.id}
                content= {question.content}
                author= {question.author}
                isAnswered= {question.isAnswered}
                isHighlighted= {question.isHighlighted} 
              >
                {!question.isAnswered && (
                  <>
                    <button
                    type="button"
                    onClick={() => handleCheckQuestionAsAnswered(question.id)}
                    >
                      <img src={checkImg} alt="Marcar pergunta como respondida"/>
                    </button> 

                    <button
                    type="button"
                    onClick={() => handleHighlightQuestion(question.id)}
                    >
                      <img src={answerImg} alt="Dar destaque à pergunta"/>
                    </button>
                  </>
                )}

                <button
                type="button"
                onClick={() => handleDeleteQuestion(question.id)}
                >
                  <img src={deleteImg} alt="Remover pergunta"/>
                </button> 
              </Question>
            );
          })}
        </div>

        <div className="btn-finisher">
        <Button isOutlined onClick={handleEndRoom}>Encerrar sala</Button>
      </div>
      
      </main>
      
    </div>
    
  );
}